import {
  productEventEmitter,
  ProductEventPayload,
} from "@made-people/grease-product";
import { useEffect } from "react";
import { useMmGtm } from "../mm-gtm-context";
import {
  gtmProductCategory,
  gtmProductImage,
  gtmProductParentId,
} from "../mm-gtm-helpers";

export const MmGtmEventViewItem = () => {
  const { pusher } = useMmGtm();

  useEffect(() => {
    const handleProductViewed = (
      params: ProductEventPayload["productViewed"],
    ) => {
      if (params.context.type === "pdp") {
        const payload = {
          event: "productDetail",
          ecommerce: {
            detail: {
              products: [
                {
                  name: gtmProductParentId(params.productData.base),
                  title: params.productData.base.content.name,
                  image: gtmProductImage(params.productData.base),
                  id: params.productData.base.productKey,
                  parentId: gtmProductParentId(params.productData.base),
                  brand: params.productData.base.content.brand,
                  category: gtmProductCategory(params.productData.base),
                  price: params.productData.purchaseInfo.priceInfo.price.number,
                },
              ],
            },
          },
        };

        // TODO: Implement this
        // if (this.$store.state.gtm) {
        //   const pushedClick = await this.$store.dispatch(
        //     "gtm/popLastPushedClick",
        //   );
        //   if (pushedClick) {
        //     const list = pushedClick?.ecommerce?.click?.actionField?.list;
        //     if (list) {
        //       payload.ecommerce.detail.actionField = { list };
        //     }
        //   }
        // }

        pusher(payload);
      }
    };

    productEventEmitter.on("productViewed", handleProductViewed);
    return () => {
      productEventEmitter.off("productViewed", handleProductViewed);
    };
  }, []);

  return null;
};
